/**
 * 未解放の大謎を示すカード（基本設計書 5.7 / 定義書 I012）。
 *
 * 開けない・選べない・入力できないカードとして描く。
 * 展開する仕組みも解答欄も持たせないのは、入力だけできて送信が拒否される作りにすると、
 * 書いた解答を送れない参加者が運営へ申し出ることになり、当日の対応が増えるためである。
 *
 * 表示名・配点・ヒントの件数も出さない。そもそもサーバーがこのカードのために返すのは
 * 「未解放の大謎がある」という真偽値ひとつだけで、問題の中身は解放されるまで届かない。
 */

export function LockedFinalCard(): React.ReactElement {
  return (
    <section className="card card--final-locked" aria-label="最終謎">
      <div className="card__head card__head--static">
        <div className="card__head-main">
          <span className="card__label">最終謎</span>
          <span className="card__meta">全問正解で解放</span>
        </div>
        <span className="badge badge--locked" aria-hidden="true">
          ？
        </span>
      </div>
    </section>
  );
}
